<svg
  class={$$props.class}
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M2.75 4.75V16.25C2.75 17.9069 4.09315 19.25 5.75 19.25H21.25M6.75 15.25L10 12C10.5523 11.4477 11.4477 11.4477 12 12V12C12.5523 12.5523 13.4477 12.5523 14 12L19.25 6.75M19.25 6.75H14.75M19.25 6.75V11.25"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
